import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "40",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"#B07722\" fill-rule=\"evenodd\" clip-path=\"url(#a)\" clip-rule=\"evenodd\" opacity=\".4\"><path d=\"M20.667 37.918c-9.88 0-17.918-8.038-17.918-17.918S10.787 2.082 20.667 2.082 38.584 10.12 38.584 20s-8.038 17.918-17.918 17.918m0-37.918c-11.029 0-20 8.972-20 20s8.971 20 20 20 20-8.972 20-20-8.972-20-20-20\"></path><path d=\"M27.13 8.992a1.041 1.041 0 0 0-1.056 1.795A10.73 10.73 0 0 1 31.349 20c0 5.89-4.792 10.682-10.682 10.682S9.985 25.89 9.985 20.001c0-3.77 2.02-7.301 5.275-9.214a1.041 1.041 0 1 0-1.056-1.795A12.82 12.82 0 0 0 7.902 20c0 7.039 5.726 12.765 12.765 12.765 7.038 0 12.764-5.726 12.764-12.765 0-4.504-2.415-8.722-6.302-11.008\"></path><path d=\"M20.666 5.847c-.575 0-1.041.466-1.041 1.04V20a1.041 1.041 0 1 0 2.082 0V6.888c0-.575-.466-1.041-1.04-1.041\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M.667 0h40v40h-40z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }